export const MANUAL_CPA = {
  key: 'manualCpa',
  text: _TL_('Manual CPI'),
  type: 'ManualCpa',
};

export const MANUAL_CPA_SCHEMA = {
  name: 'Product Schema',
  type: 'object',
  properties: {},
};
